import React from 'react';
import background from '../images/wallpaper3.jpg'
import Time from "./Time";
import IconConverter from "./IconConverter";
import WeeklyWeatherCard from './WeeklyWeatherCard';

const CardExampleCard = ({weatherData, showWeekly, setShowWeekly, weeklyData}) => {

 

    return (

    <div className="background" style={{ backgroundImage: `url(${background})` }}>
           
           <button  type="button" className="btn btn-primary btn-circle btn-xl" onClick={() => setShowWeekly(!showWeekly)}>
          <i className="glyphicon glyphicon-list"></i></button>
        <div className="city_name_background">
            <h1 className="city_name">{weatherData.name}</h1>
        </div>
        
        {weatherData.weather &&
        <div className="temprature_over_icon">
            <IconConverter className="icon" icon={weatherData.weather[0].id}/>
            <p className="temprature"> {Math.floor(weatherData.main.temp)} C°</p>
            <Time/>
         
        </div>
}
{!showWeekly && 
        <div className="info_background">
            <p>Min Temprature: {Math.floor(weatherData.main.temp_min)} C°</p>
            <p>Max Temprature: {Math.floor(weatherData.main.temp_max)} C°</p>
            <p>Humidity: {weatherData.main.humidity} %</p>
            </div>
}

{showWeekly && weeklyData && weeklyData.daily && <WeeklyWeatherCard weatherData={weeklyData} />}

  </div>

)
    }

export default CardExampleCard;